import React, { Component } from 'react';
import { Row, Col } from 'antd';
import API_URL from './../../constants/server';
import axios from 'axios';
import { connect } from 'react-redux';
import { Control, Form, actions, submit } from 'react-redux-form/immutable';
import TagsInput from 'react-tagsinput'
import 'react-tagsinput/react-tagsinput.css' 
import 'rc-slider/assets/index.css';
import Slider from 'rc-slider';
import Tooltip from '../../components/uielements/tooltip';
import Collapses from '../../components/uielements/collapse';
import _ from 'lodash';
import ReactFlagsSelect from 'react-flags-select';
import 'react-flags-select/css/react-flags-select.css';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import ContentHolder from '../../components/utility/contentHolder';
import AdPreview from '../../components/AdPreview';
import SearchIcon from '../../image/search.png';
import PlusHoverIcon from '../../image/plus_hover.png';
import DownloadGreenUpArrow from "../../image/download_green_arrow.png";
import basicStyle from '../../config/basicStyle';
import AddCampaignWrapper from './style';
import createClass from 'create-react-class';
import PropTypes from 'prop-types';
import searchAddsActions from '../../redux/searchads/actions';
import appActions from '../../redux/itunesSearch/actions';
import { bindActionCreators } from 'redux'
import CollapseWrapper from './collapse.style';
import { Formik, FieldArray } from 'formik';
import ButtonAction from '../../components/ButtonAction';

import SearchApp from "../../components/SearchAppBar/index";

// -- Resources
import TooltipVisual from "../../image/tooltip.png";
import { FLAG_LABELS } from '../../constants/country';

const Panel = Collapses.Panel;
const Collapse = props => (
  <CollapseWrapper>
    <Collapses {...props}>{props.children}</Collapses>
  </CollapseWrapper>
);

const GravatarOption = createClass({
  propTypes: {
    children: PropTypes.node,
    className: PropTypes.string,
    isDisabled: PropTypes.bool,
    isFocused: PropTypes.bool,
    isSelected: PropTypes.bool,
    onFocus: PropTypes.func,
    onSelect: PropTypes.func,
    option: PropTypes.object.isRequired,
  },
  handleMouseDown (event) {
    event.preventDefault();
    event.stopPropagation();
    this.props.onSelect(this.props.option, event);
  },
  handleMouseEnter (event) {
    this.props.onFocus(this.props.option, event);
  },
  handleMouseMove (event) {
    if (this.props.isFocused) return;
    this.props.onFocus(this.props.option, event);
  },
  render () {
    return (
      <div className={this.props.className}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
        title={this.props.option.title}>
        <div className="app-div-anchor">
          <div>
            <img src={this.props.option.options.artworkUrl60} />
          </div>
          <div>{this.props.children}</div>
        </div>
        {/* <Gravatar email={this.props.option.email} size={GRAVATAR_SIZE} style={gravatarStyle} /> */}
      </div>
    );
  }
});

import styled from 'styled-components';

const Wrapper = styled.div`
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 1.5rem;
  align-items: center; 
  margin: 5px 10px;
`;

const SplitInput = styled.input`
  line-height: 1.5;
    padding: 0.7rem 1rem;
    border: 1px solid rgba(0, 0, 0, 0.12);
    // width: 100%;
    height: 3rem;
`;
const MyTextInput = (props) => <SplitInput {...props} />;

class AddCampaignForm extends Component {

  //to be redux saga
  async getCountiresData( appName ){
    const API_PUBLIC_SEARCH =  API_URL + '/searchads/public/search/'
    try {
      const response = await axios.get(API_PUBLIC_SEARCH, 
        { params: { searchValue: appName} } )
      console.log( '[getCountiresData] ', response.data) 

      return response.data
    } catch (error) {
      return [];
      //no error for this api except network / timeout issue
      console.log( '[getCountiresData] ', error) 
    }
  }

  constructor(props) {
    super(props)
    this.state = { 
      request: null,
      repos: [],
      adamId: null
    }
  }
  
  componentDidMount(){
    console.log( 'componentDidMount');

    if (this.props.currentApp){
      this.retrieveData();
    } else {
      console.log( '[ current npp not found]', this.props.currentApp)
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    console.log( 'componentDidUpdate');

    if (  this.props.currentApp && this.props.currentApp.adamId !== prevProps.currentApp.adamId  ){
      this.retrieveData();
    } else {
    }
  }

  async getAppRecord(appId){
    const { getAccessToken } = this.props.auth;
    const headers = { 'Authorization': `Bearer ${getAccessToken()}`}
    try {
      const response = await axios.get(`${API_URL}/user/campaigns/appid/${appId}`, { headers } )
      console.log( '[getAppRecord] ', response.data.response) 
      //dirty fix
      if (response.data.response){
        this.props.history.push(`/dashboard/${appId}`);
      }
      return response.data.response
    } catch (error) {
      //no error for this api except network / timeout issue
      console.log( '[getAppRecord] ', error) 
      return [];
    }
  }
  /*
  * TODO: This call should also retrieve previous budget split state.
  */
  async retrieveData(){
    const { name, sellerName, adamId } = this.props.currentApp
    console.log( ' update component ', adamId);

    const appRecord = await this.getAppRecord(adamId); 
    console.log( ' update component ')

    let results = await this.getCountiresData(adamId);
    console.log( results, name, sellerName)

    //adamId of undefinied
    // let index = _.findIndex( results, result => result.appName === name /*&& result.developerName === sellerName*/ )

    
    
    if(results.length === 0) {
      //adamId not existed? if it does not exist then it is not good for campagin creadtion
      console.log( "adamId : " + adamId + " not found");
      return;
    }

    //compare appName and developerName
    console.log( 'getCountiresData result', results[0])

    this.props.updateStorefronts(results[0].storeFrontCountryCodes);
  }

  onSelectFlag = (countryCode) => {
    this.props.onCountryCodeUpdated(countryCode);
  }

  onSelectAsyncChange = (app) => {
    this.setState({
      value: app,
    });

    const { optionList, input } = this.state;
    if ( optionList && optionList.length > 1){
      this.props.appSelected(app.value , optionList[1].value);
    } else if ( optionList && optionList.length === 1){
      this.props.appSelected(app.value , app.value);
    } else {
      this.props.appSelected(app.value , null);    
    }
    this.props.onSearchTermUpdated(input);
  };

  getApps = (input) => {
		if (!input) {
			return Promise.resolve({ options: [] });
		}
    this.setState({ input })
 
    return axios.get(`https://itunes.apple.com/search`,
     { params: { term: input, country: this.props.countryCode, entity: 'software'}})
      .then( (response) => {
        if( response.data ){
          let itemData = response.data.results;
          let items = itemData.map( (item, i) => { 
            return { 
              key: i,
              label: item.trackCensoredName,
              id: i, 
              value: { 
                adamId: item.trackId,
                artworkUrl60: item.artworkUrl60,
                artworkUrl100: item.artworkUrl100,
                name: item.trackCensoredName,
                trackCensoredName: item.trackCensoredName,
                sellerName: item.sellerName,
                screenshotUrls: item.screenshotUrls,
                bundleId: item.bundleId
              },
              options: item
            } 
          })
          // console.log( ' itunes search ' , items );
          
          this.setState({ optionList: items })
          return { options: items };          
        }
      })
      .catch(error => {
        console.log( error.message)
      });  
  };
  goTo(route) {
    this.props.history.push(`${route}`)
  }
  render() {

    console.log( 'currentApp ', this.props.currentApp)
    const { request } = this.state;
    const { searchTerm, campaign, currentApp, secondApp, countryCode, budgetSplit} = this.props;    
    const { rowStyle, colStyle } = basicStyle;

    console.log( ' country code : ', countryCode);
    if (!currentApp){
      return (
        <div/>
      )
    }

    let formInitialValues = {
      'selectAllCountries': true,
      'depositAmount': campaign.get('depositAmount'),
      'maxCPA': campaign.get('maxCPA'),
      'currency': campaign.get('currency'),
      'budgetSplit': budgetSplit,
      'maxAmountForKeyword': campaign.get('maxAmountForKeyword'),
      'positiveKeywords': campaign.get('positiveKeywords'),
      'negativeKeywords': campaign.get('negativeKeywords'),
      'submitTerms': true,
      'isEvenlySplit': campaign.get('isEvenlySplit')
    }
    console.log( budgetSplit  + ' formInitialValues')

    return (
      <AddCampaignWrapper style={{backgroundColor: 'rgba(243, 243, 243, 1)'}}>
      <style>{"\
        .ant-tooltip-content { position: relative; }\
        .ant-tooltip-inner {\
          padding: 18px;\
          padding-bottom: 21px;\
          background-color: rgba(0, 0, 0, .65);\
          line-height: 16px;\
          font-family: 'Montserrat';\
          font-size: 13px;\
          font-weight: 300;\
          color: rgba(255, 255, 255, 1);\
          letter-spacing: 0.04em;\
          border-radius: 10px;\
          text-shadow: 0 0 1px #555;\
        }\
        .ant-tooltip-placement-top .ant-tooltip-arrow {\
          position: absolute;\
          bottom: 0;\
          border-top-color: rgba(0, 0, 0, .4);\
          transform: translateY(100%);\
        }\
      "}</style>
      <div className="header">
        {/* <div className="greenLogo">
          <img
            src={process.env.PUBLIC_URL + GreenLogo}/>
        </div> */}
        <div>只需几步，你就能获得优质下载量</div>
      </div>
      <div className="container">
          <Formik
          enableReinitialize ={ true}
           initialValues={formInitialValues}
           validate={values => {
            let errors = {};
            if (!values.submitTerms) {
              errors.submitTerms = 'Required';
            }
            return errors;
          }}
            onSubmit={(values, actions) => {
              console.log('Add campaign form', values, actions);                            

              const adamId = this.props.currentApp.adamId;
              const orderRequest = { ...values, adamId};
              console.log( 'campaign request to be submitted : ' , orderRequest)
              
              this.props.addCampaign(orderRequest)
              this.props.history.push( { pathname: '/addCampaign/confirm', state: { orderRequest } });
            }}
            
            render={({ handleSubmit, handleChange, handleBlur, setFieldValue, values, errors, dirty, touched}) => {
              console.log('form state changes','values',values,'errors',errors, 'dirty',dirty, 'touched',touched);
              
              return (<FieldArray name='budgetSplit' render={arrayHelpers =>(
                <form onSubmit={handleSubmit}>
                    <div className="section__section blackSection">
                    <div className="o-wrapper">
                        <Row style={rowStyle} gutter={0} justify="start">
                          <Col md={15} sm={24} xs={24} style={colStyle}>

                            <div className="appDisplay__app-display">
                              <span className="appDisplayImg__app-display">
                                <img src={ currentApp.artworkUrl100} alt="screen"/>
                              </span>
                              <div>
                                  <h1 className="appLongName__app-display">{ currentApp.trackCensoredName }</h1>
                                  <h2 className="appPublisher__app-display"><span>{ currentApp.sellerName }</span></h2>
                              </div>
                            </div>
                          </Col>

                          <Col md={9} sm={24} xs={24} style={colStyle}>
                            <SearchApp
                              auth={this.props.auth}
                              goTo={this.goTo.bind(this)}
                              value={this.state.value}
                              onChange={this.onChange}
                              backspaceRemoves={this.state.backspaceRemoves}
                              placeholder="更换APP"/>
                            
                          </Col>
                        </Row>
                    </div>
                  </div>
                  <div>预算</div>
                  <div className="section__section blackSection">

                      
                      <Row style={rowStyle} gutter={0} justify="start">
                          <Col md={24} sm={24} xs={24}>
                            <div className="inputWrapper">

                                  <label >你的预算是多少？</label>
                              </div>
                          </Col>
                        </Row>

                        <Row style={rowStyle} gutter={0} justify="start">


                            <Col md={12} sm={12} xs={24} style={colStyle}>
                              <ContentHolder>
                                <div className="inputWrapper" style={{marginBottom: '32px'}}>

                                  <label htmlFor="depositAmount">预算金额: 
                                    <Tooltip  title={"Your campaign will stop once this has been spent - you can top this up at any time."}>
                                      <img src={TooltipVisual} className="tooltip-label" />
                                    </Tooltip>
                                  </label>

                                  <div className="FormTextInput">
                                    <div>$  </div>
                                    <input type="number" name="depositAmount" step=".01" min="0" value={values.depositAmount} onChange={handleChange}/>
                                  </div>
                                  {/* <p>Your campaign will stop once this has been spent - you can add more budget at any time</p> */}
                                </div>
                              </ContentHolder>
                            </Col>

                            <Col md={12} sm={12} xs={24} style={colStyle}>
                              <ContentHolder>
                                <div className="inputWrapper">

                                  <label htmlFor="maxCPA">目标获客成本: 
                                    <Tooltip title={"The most you are willing to pay for a single user to download your app."}>
                                      <img src={TooltipVisual} className="tooltip-label" />
                                    </Tooltip>
                                  </label>

                                  <div className="FormTextInput">
                                    <div>$  </div>
                                    <input type="number" name="maxCPA" step=".01" min="0" value={values.maxCPA} onChange={handleChange}/>
                                  </div>
                                  {/* <p>The most you are willing to pay for a user downloading your app</p> */}


                                </div>
                              </ContentHolder>
                            </Col>
                        </Row>

                        { values.isEvenlySplit && 
                          <Row style={rowStyle} gutter={0} justify="start" className="BudgetTC">
                            <Col md={24} sm={24} xs={24} style={colStyle}>
                              <p className="budgetText">
                                你的总预算是
                                {/* {values.currency} */}
                                $ <span className="budget-cost">{values.depositAmount}</span>美金，
                                我们的智能系统会为你精准投放到各个可用应用市场。
                              </p>
                            </Col>
                          </Row>
                        }
              
                        <Row style={rowStyle} gutter={0} justify="start" hidden>
                            <Col md={8} sm={12} xs={24} style={colStyle}>
                              <ContentHolder>
                                  <div className="inputWrapper">
                                      <div className="field">
                                        <label>Choose your Currency</label>
                                        <input type="text" name="currency" value={values.currency} onChange={handleChange}/>
                                      </div>
                                  </div>
                              </ContentHolder>
                            </Col>
                        </Row>
                        
                        { values.isEvenlySplit && 
                          <Row style={rowStyle} gutter={0} justify="start">
                            <Col md={24} sm={24} xs={24} style={colStyle}>
                              <div className="budgetSimpleWrapper">
                                <div>
                                  <input type="checkbox" 
                                    name="selectAllCountries"
                                    checked={ values.selectAllCountries }
                                    onChange={ e => {
                                      
                                      handleChange(e);

                                      let selectedCountries = [];

                                      values.budgetSplit.forEach((budgetItem, index) => {
                                        if (!budgetItem.display) return;

                                        setFieldValue(`budgetSplit.${index}.selected`, e.target.checked);
                                        if (e.target.checked) {
                                          selectedCountries.push(index)
                                        } else {
                                          setFieldValue(`budgetSplit.${index}.value`, 0);
                                        }
                                      });

                                      let storefrontCount = selectedCountries.length;
                                      let newAmount = +parseFloat(values.depositAmount/ storefrontCount).toFixed(2);
                                      selectedCountries.forEach((index)=> {
                                        setFieldValue(`budgetSplit.${index}.value`, newAmount);
                                      });

                                    } }
                                    />
                                  <span className="allCountryLabel">全部可投放国家</span>
                                </div>
                                <div className="ant-row">
                                {/* Simple list begins */}
                                  {  values.budgetSplit.map((budgetItem, index) => {
                                      const regionCode = budgetItem.key;
                                      const selected = budgetItem.selected;

                                      if (!budgetItem.display){
                                        return null;
                                      }
                                      return (
                                        <div className="ant-col-6" key={ regionCode }>
                                            <input 
                                              type="checkbox" 
                                              name={`budgetSplit.${index}.selected`}
                                              checked={ budgetItem.selected }
                                              onChange={ e => {

                                                handleChange(e)
                                                

                                                let selectedCountries = [];
                                                let isOtherCountriesSameStatus = true;

                                                values.budgetSplit.forEach((v, k) => {
                                                  if (!v.display || k===index) return;

                                                  if (v.selected!==e.target.checked) {
                                                    isOtherCountriesSameStatus = false;
                                                  }
                                                  
                                                  if (v.selected) {
                                                    selectedCountries.push(k);
                                                  }
                                                });

                                                if (isOtherCountriesSameStatus) {
                                                  setFieldValue('selectAllCountries', e.target.checked)
                                                } else {
                                                  setFieldValue('selectAllCountries', false)
                                                }

                                                if (e.target.checked) {
                                                  selectedCountries.push(index);
                                                }

                                                let storefrontCount = selectedCountries.length;
                                                let newAmount = +parseFloat(values.depositAmount/ storefrontCount).toFixed(2);
                                                values.budgetSplit.forEach((budgetItem, index) => {
                                                  if (selectedCountries.indexOf(index) > -1) {
                                                    setFieldValue(`budgetSplit.${index}.value`, newAmount);
                                                  } else {
                                                    setFieldValue(`budgetSplit.${index}.value`, 0);
                                                  }
                                                });
                                              } }
                                            />
                                            <ReactFlagsSelect 
                                              className="regionInput"
                                              defaultCountry={ regionCode } 
                                              customLabels={FLAG_LABELS} 
                                              showSelectedLabel={ true } 
                                              disabled={ true }/>
                                        </div>
                                      );
                                    }) }
                                {/* Simple list ends */}
                                </div>

                              </div>
                            </Col>
                          </Row>
                        }

                        <Collapse bordered={false} className="advanced-settings" onChange={ (key) => {
                            let isEvenlySplit = !(key.indexOf("1") > - 1);
                            setFieldValue('isEvenlySplit', isEvenlySplit)
                            
                            let storefrontCount = values.budgetSplit.filter(b=>(b.selected)).length;
                            let newAmount = +parseFloat(values.depositAmount/storefrontCount).toFixed(2);
                            if (isEvenlySplit) {
                              values.budgetSplit.forEach((v,k)=> {
                                if(v.selected) {
                                  setFieldValue(`budgetSplit.${k}.value`, newAmount);
                                } else {
                                  setFieldValue(`budgetSplit.${k}.value`, 0);
                                }
                              });
                            }
                          }} >
                          <Panel
                            header={<div style={{display:'inline',verticalAlign:'middle'}}> {"进阶设定"} {<span> {"（选填）"} </span>} </div>}
                            key="1"
                          >
                            <div>
                              <label>你想如何分配你的预算？</label>
                              <p>
                                {/* Your total budget is {values.currency}$ , please split this across each of the app stores */}
                                你的总预算是{values.depositAmount}美金，请按需要分配到各个应用市场。
                              </p>
                              {/* <p>Budget remain: {campaign.currency}$ {campaign.depositAmount - this.state.budgetSplit.reduce((pv,cv)=>{ return pv + cv.value;},0)}</p> */}
                              
                              {/* Advance list begins */}
                              {   
                                  values.budgetSplit.map((budgetItem, index) => {
                                  const regionCode = budgetItem.key;
                                  if (!budgetItem.display || !budgetItem.selected){
                                    return null;
                                  }
                                  // console.log( '[budgetItem]', budgetItem)

                                  let percentValue = budgetItem.value / values.depositAmount * 100;
                                  
                                  // console.log( '[percentValue]', percentValue)
                                  return (
                                  <Wrapper key={ regionCode}>
                                      <ReactFlagsSelect 
                                        className="regionInput"
                                        defaultCountry={regionCode} 
                                        customLabels={FLAG_LABELS}
                                        showSelectedLabel={true} 
                                        disabled={true}/>


                                      <Slider
                                        ref={ref => {
                                          ref && ref.sliderRef.getElementsByClassName("rc-slider-track")[0].setAttribute("desc",ref.state.value + '%');
                                          ref && ref.sliderRef.setAttribute("desc",ref.state.value + '%'); 
                                          ref && ref.sliderRef.parentElement.setAttribute("desc",ref.state.value + '%');      
                                        }}
                                        key={`slider-${regionCode}`} 
                                        min={0} max={100} 
                                        value={ percentValue }
                                        step={1}
                                        onChange={ ( value ) =>{

                                          if (values.budgetSplit.filter(v=>v.selected).length === 1) return; // Can't adjust if only 1 country is selected

                                          let thisAmount = value / 100 * values.depositAmount;
                                          let deltaAmount = thisAmount - values.budgetSplit[index].value;

                                          console.log('country',values.budgetSplit[index].key,'this amount', thisAmount, 'delta', deltaAmount);

                                          if (deltaAmount > 0) {
                                            // Subtract from other storefronts on pro rata basis to compensate the surplus in deposit allocated
                                            values.budgetSplit.forEach((v,k)=> {
                                              if (k!==index && v.selected) {
                                                let newAmount = v.value - deltaAmount;
                                                if (newAmount < 0) {
                                                  deltaAmount = -newAmount;
                                                  newAmount = 0; 
                                                } else {
                                                  deltaAmount = 0;
                                                }

                                                newAmount = +parseFloat(newAmount).toFixed(2);
                                                console.log('update budget item', v.key, v.value, 'new amount', newAmount)
                                                setFieldValue(`budgetSplit.${k}.value`, newAmount);
                                              }
                                            });
                                          } else {
                                              // Add surplus to other storefronts so the total remains the same
                                              let storefrontCount = values.budgetSplit.filter(b=>(b.selected)).length;
                                              values.budgetSplit.forEach((v,k)=> {
                                                if (k!==index && v.selected) {
                                                  let newAmount = v.value + (-deltaAmount/(storefrontCount-1));
                                                  newAmount = +parseFloat(newAmount).toFixed(2);
                                                  console.log('update budget item', v.key, v.value, 'new amount', newAmount)
                                                  setFieldValue(`budgetSplit.${k}.value`, newAmount);
                                                }
                                              });
                                          }

                                          thisAmount = +parseFloat(thisAmount).toFixed(2);
                                          // console.log('update budget item', index, 'new amount', thisAmount)
                                          setFieldValue(`budgetSplit.${index}.value`, thisAmount)
                                        }}/>

                                      <div className="inputWrapper">

                                        <div className="FormTextInput">
                                          <div>$  </div>
                                          <input type="number" name={`budgetSplit.${index}.value`} min="0" step=".01" max={values.depositAmount} value={ budgetItem.value } onChange={(e)=>{
                                            
                                            if (values.budgetSplit.filter(v=>v.selected).length === 1) return; // Can't adjust if only 1 country is selected
                                            
                                            let thisAmount = +e.target.value;
                                            if (thisAmount > values.depositAmount) {
                                              thisAmount = values.depositAmount;
                                            }
                                            let deltaAmount = thisAmount - values.budgetSplit[index].value;
  
                                            console.log('country',values.budgetSplit[index].key,'this amount', thisAmount, 'delta', deltaAmount);
  
                                            if (deltaAmount > 0) {
                                              // Subtract from other storefronts on pro rata basis to compensate the surplus in deposit allocated
                                              values.budgetSplit.forEach((v,k)=> {
                                                if (k!==index && v.selected) {
                                                  let newAmount = v.value - deltaAmount;
                                                  if (newAmount < 0) {
                                                    deltaAmount = -newAmount;
                                                    newAmount = 0; 
                                                  } else {
                                                    deltaAmount = 0;
                                                  }
  
                                                  newAmount = +parseFloat(newAmount).toFixed(2);
                                                  console.log('update budget item', v.key, v.value, 'new amount', newAmount)
                                                  setFieldValue(`budgetSplit.${k}.value`, newAmount);
                                                }
                                              });
                                            } else {
                                                // Add surplus to other storefronts so the total remains the same
                                                let storefrontCount = values.budgetSplit.filter(b=>(b.selected)).length;
                                                values.budgetSplit.forEach((v,k)=> {
                                                  if (k!==index && v.selected) {
                                                    let newAmount = v.value + (-deltaAmount/(storefrontCount-1));
                                                    newAmount = +parseFloat(newAmount).toFixed(2);
                                                    console.log('update budget item', v.key, v.value, 'new amount', newAmount)
                                                    setFieldValue(`budgetSplit.${k}.value`, newAmount);
                                                  }
                                                });
                                            }

                                            thisAmount = +parseFloat(thisAmount).toFixed(2);
                                            // console.log('update budget item', index, 'new amount', thisAmount)
                                            setFieldValue(`budgetSplit.${index}.value`, thisAmount)
                                          }}/>
                                        </div>
                                        {/* <p>Your campaign will stop once this has been spent - you can add more budget at any time</p> */}

                                      </div>
                                    
                                    </Wrapper>  
                                )}) }
                              {/* Advance list ends */}
                              <Row style={rowStyle} gutter={0} justify="start">
                            <Col md={24} sm={24} xs={24}>
                              <p>有哪些特定关键词你希望加入竞价？</p>
                            </Col>

                            <Col md={8} sm={12} xs={24} style={colStyle}>
                              <ContentHolder>
                                <div className="inputWrapper">

                                  <label>添加特定关键词: 
                                    <Tooltip title={"You don't need to add any keywords here unless you sure they are more valuable to you."}>
                                      <img src={TooltipVisual} className="tooltip-label" />
                                    </Tooltip>
                                  </label>

                                  <TagsInput 
                                    onKeyPress={e => { if (e.key === 'Enter') e.preventDefault();}} 
                                    value={values.positiveKeywords} 
                                    onChange={tags=>{setFieldValue('positiveKeywords',tags)}} />
                                  <img src={PlusHoverIcon}/>
                                </div>
                              </ContentHolder>
                            </Col>
                            <Col md={8} sm={12} xs={24} style={colStyle}>
                              <ContentHolder>
                                <div className="inputWrapper">

                                  <label htmlFor="maxAmountForKeyword">
                                    最高消费金额限制:
                                    <Tooltip title={"The maximum amount you are willing to pay for a customer for these keywords."}>
                                      <img src={TooltipVisual} className="tooltip-label" />
                                    </Tooltip>
                                  </label>

                                  <div className="FormTextInput">
                                    <div>$  </div>
                                    <input type="number" name="maxAmountForKeyword" step=".01" min="0" value={values.maxAmountForKeyword} onChange={handleChange}/>
                                  </div>
                                

                                </div>
                              </ContentHolder>
                            </Col>
                            <Col md={8} sm={12} xs={24} style={colStyle}>
                              <ContentHolder>
                                <div className="inputWrapper">

                                  <label>添加否定关键词: 
                                    <Tooltip title={"The negative keywords that you don't want your app to show up for."}>
                                      <img src={TooltipVisual} className="tooltip-label" />
                                    </Tooltip>
                                  </label>

                                  <TagsInput 
                                    onKeyPress={e => { if (e.key === 'Enter') e.preventDefault();}} 
                                    value={values.negativeKeywords} 
                                    onChange={tags=>{setFieldValue('negativeKeywords',tags)}} />
                                  <img src={PlusHoverIcon}/>
                                </div>
                              </ContentHolder>
                            </Col>
                        </Row>

                            </div>
                          </Panel>
                          
                        </Collapse>
                          

                      
                        <div className={this.props.className}>
                        
                        </div>


                      
                      <Row style={rowStyle} gutter={0} justify="start">
                                  
                        <Col md={24} sm={24} xs={24} style={colStyle}>
                          <div className="campaign-holder">
                            <Row style={rowStyle} gutter={0} justify="start">
                                  <Col md={10} sm={24} xs={24} style={colStyle}>
                                      <ContentHolder>

                                          <AdPreview
                                            currentApp={ currentApp }
                                            secondApp={ secondApp }
                                            searchTerm={ searchTerm }
                                          />
                                      </ContentHolder>
                                  </Col>
                                  <Col md={14} sm={24} xs={24} style={colStyle}>
                                    <button className="btn-create-campaign" type="submit">
                                      创建廣告項目
                                      <img src={DownloadGreenUpArrow} alt='down-green-arrow'/>
                                    </button>
                                    
                                    <div className="submit-terms">
                                      <input type="checkbox" id="submitTerms" checked={values.submitTerms} onChange={handleChange}/>
                                      <label htmlFor="submitTerms">
                                      勾选这个项目表示你同意我们向你发放最新资讯及优惠。
                                      </label>
                                      {errors.submitTerms && touched.submitTerms ? <small>Please confirm to proceed.</small> : <small/>}
                                      <div>
                                        我已阅读并同意Project X平台
                                        <a href="#">服务协议</a>.
                                      </div>
                                    </div>
                                  </Col>
                            </Row>
                          </div>
                        </Col>
                                
                      </Row>
                  </div>
                </form>
              )} />
            )}}
          />
        </div>
    
      </AddCampaignWrapper>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return { 
    appSelected: bindActionCreators(appActions.appSelected, dispatch),
    onSearchTermUpdated:  (searchTerm) => dispatch(appActions.searchTermUpdated(searchTerm)) ,
    onSearchAdsResultLocated: ( searchAppResult ) => dispatch(searchAddsActions.setSelectedResult(searchAppResult)) ,
    onCountryCodeUpdated:  (countryCode) => dispatch(appActions.countryCodeUpdated(countryCode)) ,
    updateScrollValue: ( model , value) => 
      dispatch(actions.change(model, value )
    ),
    updateStorefronts: storefonts => {
      dispatch({
        type: 'UPDATE_STOREFRONTS',
        value: storefonts
      })
    },
    addCampaign: campaign => {
      dispatch({
        type: 'ADD_CAMPAIGN',
        value: campaign
      })
    }
  }
}
function mapStateToProps(state) {
  return { 
    search: state.get('search'),
    campaign: state.get('campaign'),
    budgetSplit: state.getIn( ['campaign', 'budgetSplit']),
    currentApp: state.getIn( ['ItunesSearch', 'currentApp']),
    secondApp: state.getIn( ['ItunesSearch', 'secondApp']),
    searchTerm: state.getIn( ['ItunesSearch', 'searchTerm']),
    countryCode: state.getIn( ['ItunesSearch', 'countryCode'])  && 'US',
  }
}



export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddCampaignForm);



// WEBPACK FOOTER //
// ./src/containers/AddCampaignForm/index.js